export default "__VITE_ASSET__cf01ccf0__"